export default () => {
  if ($('.cfp-detail-top-back a').length && window.location.search.length) {
    let linkUrl = $('.cfp-detail-top-back a').attr('href');
    linkUrl += window.location.search;
    $('.cfp-detail-top-back a').attr('href', linkUrl);
  }
};